


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { BButton, BFormInput, BModal } from 'bootstrap-vue';

@Component({
    name: 'ModalUserPasswordForgot',
    components: {
        'b-button': BButton,
        'b-modal': BModal,
        'b-form-input': BFormInput,
    },
})
export default class ModalUserPasswordForgot extends Vue {
    error = '';
    updating = false;
    email = '';

    async send() {
        if (!this.email) {
            return;
        }
        this.updating = true;
        try {
            await this.$store.dispatch('account/requestToken', this.email);
            this.$bvModal.hide('modalUserPasswordForgot');
        } catch (e) {
            this.error = e.toString();
        } finally {
            this.updating = false;
        }
    }
}
